'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoCheckmarkCircled = function IoCheckmarkCircled(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 2.5c9.7 0 17.5 7.8 17.5 17.5s-7.8 17.5-17.5 17.5-17.5-7.8-17.5-17.5 7.8-17.5 17.5-17.5z m9 11.6c0.1 0 0.1-0.1 0.1-0.2s0-0.2-0.1-0.3l-2.4-1.9c-0.1-0.1-0.3-0.1-0.4-0.1s-0.1 0-0.2 0.1l-8.7 11.2s-3.4-3.3-3.5-3.4-0.3-0.2-0.4-0.2-0.3 0.2-0.4 0.2l-2 2.1c-0.1 0-0.1 0.2-0.1 0.3s0 0.1 0.1 0.2l0.2 0.1s6.1 5.8 6.1 5.9 0.3 0.3 0.4 0.3 0.3-0.2 0.4-0.3z' })
        )
    );
};

exports.default = IoCheckmarkCircled;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/checkmark-circled.js
// module id = 2465
// module chunks = 168707334958949